import { API } from 'aws-amplify';

export type ChangeMapSubjectInput = {
  student_id: string;
  test_key: string;
};

export async function changeMapSubject(input: ChangeMapSubjectInput): Promise<any> {
  try {
    const apiName = process.env.NEXT_PUBLIC_DASH_API_NAME!;
    const path = `api/testing/map/change-subject`;
    const myInit = {
      headers: {},
      body: input,
    };
    return await API.put(apiName, path, myInit);
  } catch (error) {
    console.error('Error changing map subject:', error);
    throw error;
  }
}
